import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierParticularityController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierParticularityController.php
* @route '/api/dossier/update-particularity/{dossier}'
*/
const UpdateDossierParticularityController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierParticularityController.url(args, options),
    method: 'put',
})

UpdateDossierParticularityController.definition = {
    methods: ["put"],
    url: '/api/dossier/update-particularity/{dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierParticularityController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierParticularityController.php
* @route '/api/dossier/update-particularity/{dossier}'
*/
UpdateDossierParticularityController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierParticularityController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierParticularityController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierParticularityController.php
* @route '/api/dossier/update-particularity/{dossier}'
*/
UpdateDossierParticularityController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierParticularityController.url(args, options),
    method: 'put',
})

export default UpdateDossierParticularityController